import login from './login';

export default {
  language: 'ro',
  country: 'ro',
  name: 'Română',
  embeddedLocale: login,
};
